import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { TokenContext } from "./TokenContext";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import ModalComponent from "./ModalComponent";
import Repo from "../Utility/Repo";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function DiarioDiBordoComponent({ diarioDiBordo, cartellaSocialeId }) {
  const apiToken = useContext(TokenContext);
  const [showModalAdd, setshowModalAdd] = useState(false);
  const [showModalModify, setshowModalModify] = useState(false);

  const [error, setError] = useState("");
  const [descrizione, setDescrizione] = useState("");
  const [tempId, setTempId] = useState();

  const [parmCartellaSocialeId, setParmCartellaSocialeId] = useState("");

  useEffect(() => {
    setParmCartellaSocialeId(cartellaSocialeId);
  }, [cartellaSocialeId]);

  const resetFormFields = () => {
    setDescrizione("");
    setError("");
  };

  const toggleModalAdd = () => {
    setshowModalAdd(!showModalAdd);
    resetFormFields();
  };

  const toggleModalModify = () => {
    setshowModalModify(!showModalModify);
  };

  const handleCloseModalAdd = () => {
    setshowModalAdd(false);
    resetFormFields();
  };

  const handleCloseModalModify = () => {
    setshowModalModify(false);
    resetFormFields();
  };

  const showAdd = () => {
    setDescrizione("");
    setshowModalAdd(true);
  };

  const handleDelete = (recordId) => {
    const confirmDelete = window.confirm(
      "Sei sicuro di voler eliminare questo record?"
    );

    if (confirmDelete) {
      Repo.DelDiarioDiBordo(apiToken, recordId)
        .then(() => {
          window.location.reload();
        })
        .catch((error) => {
          Repo.handleApiError(error, setError);
        });
    }
  };

  const handleModify = (recordId, description) => {
    setDescrizione(description);
    setTempId(recordId);
    toggleModalModify();
    bodyModify();
  };

  const handleSave = () => {
    Repo.AddDiarioDiBordo(apiToken, parmCartellaSocialeId, descrizione)
      .then((response) => {
        if (response.status === 200) {
          setshowModalAdd(false);
          window.location.reload();
        }
      })
      .catch((error) => {
        Repo.handleApiError(error, setError);
      });

    resetFormFields();
  };

  const handleUpd = (id) => {
    Repo.UpdDiarioDiBordo(apiToken, id, descrizione)
      .then((response) => {
        if (response.status === 200) {
          setshowModalAdd(false);
          window.location.reload();
        }
      })
      .catch((error) => {
        Repo.handleApiError(error, setError);
      });
  };

  const bodyAdd = () => {
    return (
      <>
        <div className="row mb-lg-3">
          Inserisci una nuova nota nel diario di bordo
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div>
              <label htmlFor="descrizione">Note:</label>

              <ReactQuill
                theme="snow"
                name="descrizione"
                id="descrizione"
                value={descrizione}
                onChange={(e) => setDescrizione(e)}
                style={{
                  width: "100%",
                  height: "300px",
                  paddingBottom: "50px",
                }}
              />
            </div>

            <div className="d-flex justify-content-end">
              {!error && (
                <button
                  className="btn btn-primary btn-salva"
                  type="button"
                  onClick={() => handleSave()}
                >
                  Salva
                </button>
              )}
            </div>
            {error && (
              <div className="alert alert-danger mt-2" role="alert">
                <b>Attenzione:</b> {error}.
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  const bodyModify = () => {
    return (
      <>
        <div className="row">
          <div className="col-lg-12">
            <div className="col-lg-12">
              <label htmlFor="descrizione">Note:</label>
              <ReactQuill
                theme="snow"
                name="descrizione"
                id="descrizione"
                value={descrizione}
                onChange={(e) => setDescrizione(e)}
                style={{
                  width: "100%",
                  height: "300px",
                  paddingBottom: "50px",
                }}
              />
            </div>

            <div className="d-flex justify-content-end clearfix">
              {!error && (
                <button
                  className="btn btn-primary btn-salva"
                  type="button"
                  onClick={() => handleUpd(tempId)}
                >
                  Modifica
                </button>
              )}
            </div>
            {error && (
              <div className="alert alert-danger mt-2" role="alert">
                <b>Attenzione:</b> {error}.
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="col-lg-12">
      <div className="card-wrapper card-space">
        <div className="card card-bg no-after card-big roundedCustom">
          <div className="etichetta">
            <svg className="icon icon-primary">
              <use href={`${iconSprite}#it-plus`}></use>
            </svg>
            <span>
              {" "}
              <a
                className="text-decoration-none"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  showAdd();
                }}
              >
                Aggiungi
              </a>
            </span>
          </div>
          <div className="card-body" key="anamnesiFamiliari">
            <div className="row">
              <div className="col-lg-9">
                <h5>Diario di bordo</h5>
              </div>
            </div>
            {diarioDiBordo && diarioDiBordo.length > 0 ? (
              diarioDiBordo.map((diario) => (
                <div key={diario.id}>
                  <div className="d-flex justify-content-between">
                    <div>
                      <p>
                        {" "}
                        Data: <strong>{diario.dataUpdate}</strong>
                      </p>
                    </div>
                    <div>
                      <div>
                        <button
                          className="btn btn-outline-primary p-1"
                          type="button"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Modifica"
                          onClick={() =>
                            handleModify(diario.id, diario.descrizione)
                          }
                        >
                          <svg className="icon icon-primary">
                            <use href={`${iconSprite}#it-pencil`} />
                          </svg>
                        </button>

                        <button
                          className="btn btn-outline-danger p-1 ml-1"
                          type="button"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Elimina"
                          onClick={() => handleDelete(diario.id)}
                        >
                          <svg className="icon icon-danger">
                            <use href={`${iconSprite}#it-delete`} />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div
                    dangerouslySetInnerHTML={{ __html: diario.descrizione }}
                  />
                  <hr />
                </div>
              ))
            ) : (
              <>Non sono state inserite note.</>
            )}
          </div>
        </div>
      </div>

      <ModalComponent
        toggleModal={toggleModalAdd}
        isOpen={showModalAdd}
        header="Aggiungi"
        body={bodyAdd()}
        buttonDeny="Chiudi"
        onClose={handleCloseModalAdd}
      />

      <ModalComponent
        toggleModal={toggleModalModify}
        isOpen={showModalModify}
        header="Modifica"
        body={bodyModify()}
        buttonDeny="Chiudi"
        onClose={handleCloseModalModify}
      />
    </div>
  );
}

export default DiarioDiBordoComponent;
